"use client";

import { c as _c } from "react/compiler-runtime";
import { Col } from "react-bootstrap";
import styles from "../NFTImage.module.scss";
import NFTImageBalance from "../NFTImageBalance";
import NFTModel from "../NFTModel";
import { BaseRendererProps } from "../types/renderer-props";
export default function NFTModelRenderer(props) {
  const $ = _c(11);
  if (!("metadata" in props.nft)) {
    return null;
  }
  const t0 = `${styles.nftAnimation} ${props.imageStyle} ${props.bgStyle} d-flex justify-content-center align-items-center`;
  let t1;
  if ($[0] !== props.height || $[1] !== props.nft || $[2] !== props.showBalance) {
    t1 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
    $[0] = props.height;
    $[1] = props.nft;
    $[2] = props.showBalance;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.id || $[5] !== props.nft) {
    t2 = <NFTModel nft={props.nft} id={props.id} />;
    $[4] = props.id;
    $[5] = props.nft;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = <Col className={t0}>{t1}{t2}</Col>;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}